import { render } from "./AssociateDnsZone.vue?vue&type=template&id=250d2806&scoped=true"
import script from "./AssociateDnsZone.vue?vue&type=script&lang=js"
export * from "./AssociateDnsZone.vue?vue&type=script&lang=js"

import "./AssociateDnsZone.vue?vue&type=style&index=0&id=250d2806&lang=less&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-250d2806"]])

export default __exports__